


















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';
import { uniqueId } from 'lodash';

@Component
export default class StoreComponent extends Vue {
  @Prop()
  public title: string;

  @Prop()
  public filterCount: number;

  @Prop({
    default: false
  })
  public hasFilter: boolean;

  @Prop()
  public open: number;

  public search: string = '';

  private filterTimeout: number|null = null;

  public get titleId(): string {
    return uniqueId('store-component-title-');
  }

  @Watch('open')
  public onOpenChanged(newValue: boolean): void {
    if (!newValue) {
      this.setDefaultState();
    }
  }

  @Emit('closeModal')
  public emitCloseModal(): void {
    this.setDefaultState();
  }

  public emitFilter(): void {
    this.debounceFilter(() => {
      this.search = this.search.trim().toLocaleLowerCase();
      this.$emit('filter', this.search);
    });
  }

  public t(key: string): TranslateResult {
    return i18n.t(key);
  }

  private setDefaultState(): void {
    this.search = '';
  }

  private debounceFilter(callback: () => void): void {
    if (this.filterTimeout !== null) {
      clearTimeout(this.filterTimeout);
    }

    this.filterTimeout = setTimeout(() => callback(), 500);
  }
}
